import { Component, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { GungBase } from 'gung-standard';
import { JeevesModalService } from 'gung-standard-jeeves';

@Component({
    selector: 'tylo-customer-delivery-location-cart-list',
    templateUrl: './tylo-customer-delivery-location-cart-list.component.html',
    styleUrls: ['./tylo-customer-delivery-location-cart-list.component.css'],
    standalone: false
})
export class TyloCustomerDeliveryLocationCartListComponent extends ListItemRendererComponent<GungBase> {  protected jeevesModalService = inject(JeevesModalService);

  openModalCreate(deliveryLocation: GungBase) {
    const newDeliveryLocation = {
      ...deliveryLocation,
      id: null,
      extra: {
        ...deliveryLocation.extra,
        fr: {}
      }
    };
    this.jeevesModalService.openCustomerDeliveryLocationModal(newDeliveryLocation);
  }

  openModalEdit(deliveryLocation: GungBase) {
    this.jeevesModalService.openCustomerDeliveryLocationModal(deliveryLocation);
  }
}
